export const EDITABLE_TEXT_FIELD_NAME = 'editable-text-value';
export type EditableTextFormikValues = {
  'editable-text-value': string;
};
